import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import LandingPage from "@/pages/LandingPage";
import AuthCallback from "@/pages/AuthCallback";
import UserDashboard from "@/pages/UserDashboard";
import MerchantDashboard from "@/pages/MerchantDashboard";
import InfluencerDashboard from "@/pages/InfluencerDashboard";
import CouponDetails from "@/pages/CouponDetails";
import ValidationPage from "@/pages/ValidationPage";
import ProfileSetup from "@/pages/ProfileSetup";
import LeaderboardPage from "@/pages/LeaderboardPage";
import EditProfilePage from "@/pages/EditProfilePage";
import AdminDashboard from "@/pages/AdminDashboard";
import EditUserProfilePage from "@/pages/EditUserProfilePage";
import SobreNos from "@/pages/SobreNos";
import PoliticaPrivacidade from "@/pages/PoliticaPrivacidade";
import CategoriesPage from "@/pages/CategoriesPage";
import CategoryPage from "@/pages/CategoryPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Footer } from "@/components/Footer";

const PAGES_WITH_OWN_FOOTER = ['/sobre-nos', '/politica-de-privacidade', '/categorias'];

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_token=')) {
    return <AuthCallback />;
  }

  const showGlobalFooter = !PAGES_WITH_OWN_FOOTER.includes(location.pathname) && !location.pathname.startsWith('/categorias/');
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/sobre-nos" element={<SobreNos />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/categorias" element={<CategoriesPage />} />
        <Route path="/categorias/:slug" element={<CategoryPage />} />
        <Route path="/setup" element={<ProtectedRoute><ProfileSetup /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
        <Route path="/merchant" element={<ProtectedRoute><MerchantDashboard /></ProtectedRoute>} />
        <Route path="/influencer" element={<ProtectedRoute><InfluencerDashboard /></ProtectedRoute>} />
        <Route path="/coupons/:couponId" element={<ProtectedRoute><CouponDetails /></ProtectedRoute>} />
        <Route path="/validate/:claimId" element={<ProtectedRoute><ValidationPage /></ProtectedRoute>} />
        <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />
        <Route path="/edit-profile" element={<ProtectedRoute><EditProfilePage /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/edit-user-profile" element={<ProtectedRoute><EditUserProfilePage /></ProtectedRoute>} />
      </Routes>
      {showGlobalFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
